import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.snapdoc";
export interface CaptureCharacteristics {
    flashOn: boolean;
    frontFacing: boolean;
}
function createBaseCaptureCharacteristics(): CaptureCharacteristics {
    return { flashOn: false, frontFacing: false };
}
export const CaptureCharacteristics: MessageFns<CaptureCharacteristics> = {
    encode(message: CaptureCharacteristics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.flashOn !== false) {
            writer.uint32(8).bool(message.flashOn);
        }
        if (message.frontFacing !== false) {
            writer.uint32(16).bool(message.frontFacing);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): CaptureCharacteristics {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCaptureCharacteristics();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.flashOn = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.frontFacing = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<CaptureCharacteristics>, I>>(base?: I): CaptureCharacteristics {
        return CaptureCharacteristics.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<CaptureCharacteristics>, I>>(object: I): CaptureCharacteristics {
        const message = createBaseCaptureCharacteristics();
        message.flashOn = object.flashOn ?? false;
        message.frontFacing = object.frontFacing ?? false;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
